<div class="project-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Objects Measurement</p>
    <h1>Objects Measurement</h1>
    <div class="meta-badges">
      <span>Java</span>
      <span>Vision</span>
      <span>Android</span>
      <span>SQLite</span>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Ruler Real Items Measure is an original, useful tool for measuring real objects in real time
        with a mobile camera.
      </p>

      <ul class="feature-list">
        <li>Measure real objects using the device camera.</li>
        <li>Use computer vision to estimate object dimensions.</li>
        <li>Keep the workflow lightweight and practical.</li>
        <li>Present measurements through an elegant mobile interface.</li>
      </ul>

      <a class="project-link" target="_blank"
         href="https://play.google.com/store/apps/details?id=pl.jawegiel.mierzenieopencv&hl=en">Download on Google
        Play</a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_main_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_auto_size_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_manu_size_1_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_auto_distance_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_manu_size_2_m_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_manu_size_2_dm_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_manu_size_2_cm_en.jpg"
           alt="Objects Measurement screenshot">
      <img class="phone-shot" src="../../../../assets/images/objects_measure_manu_distance_en.jpg"
           alt="Objects Measurement screenshot">
    </aside>
  </div>
</div>
